import styled, { css } from 'styled-components';
import {
  CARD_DESKTOP_ROUNDING,
  CARD_MIN_HEIGHT,
  CARD_MIN_HEIGHT_HO,
  OVERLAY_MIN_HEIGHT,
} from '@/app/components/search/components/EvolutionCard/constants.ts';
import { CARD_TYPE } from '@/app/components/search/components/EvolutionCard/types.ts';

export const desktopStyles = css`
  display: flex;
`;

export const overlayDesktopStyles = css`
  display: flex;
  flex-direction: column;
  min-height: ${OVERLAY_MIN_HEIGHT};
`;

export const overlayMobileStyles = css`
  display: flex;
  width: calc(100vw - 32px);
  min-height: unset;
  height: 100%;
  align-items: stretch;
`;

const standardHoverStyles = css`
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.largeDownShadow};
  }
`;

export const hoverStyles = css`
  cursor: pointer;
  ${standardHoverStyles};
`;

const hotelOnlyStyles = css`
  min-height: ${CARD_MIN_HEIGHT_HO};
`;

const mobileOnlyStyles = css`
  min-height: unset;
`;

const pulseShadowStyles = (shadowColor: string, duration: number) => css`
  @keyframes pulseShadow {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: 0 0 0 3px ${shadowColor};
    pointer-events: none;
    animation: pulseShadow ${duration}s ease-in-out 1 forwards;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
      box-shadow: 0 0 0 2px ${shadowColor};
    }
  }
`;

export const CardOuterContainer = styled.div<{ isHighlighted?: boolean }>`
  position: relative;
  max-width: 100%;
  border-radius: ${CARD_DESKTOP_ROUNDING};

  /* pulse shadow when highlighted */
  ${({ isHighlighted, theme }) =>
    isHighlighted &&
    css`
      ${pulseShadowStyles(theme.kallisto.color.background.static.backgroundBrandPrimary, 1.1)};
    `};
`;

const cardTypesStyles = css<{ type?: CARD_TYPE }>`
  ${({ type }) => {
    if (type === CARD_TYPE.MODAL) {
      return css`
        flex-direction: row !important;
        min-height: unset !important;
      `;
    }
    return css``;
  }}
`;

export const CardContainer = styled.div<{
  isOverlay: boolean;
  isNotClickable?: boolean;
  isHO?: boolean;
  ref?: React.MutableRefObject<HTMLDivElement | undefined>;
  type?: CARD_TYPE;
}>`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  position: relative;
  width: 100%;
  min-height: ${CARD_MIN_HEIGHT};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  border-radius: ${CARD_DESKTOP_ROUNDING};
  max-width: 100%;
  z-index: 1;
  container-name: card-container;
  container-type: inline-size;

  * {
    letter-spacing: 0;
  }

  ${({ isNotClickable }) => !isNotClickable && hoverStyles};
  @media (max-width: 767px) {
    ${mobileOnlyStyles};
    ${({ isOverlay }) => isOverlay && overlayMobileStyles};
  }
  @media (min-width: 768px) {
    ${desktopStyles};
    ${({ isOverlay }) => isOverlay && overlayDesktopStyles};
  }
  ${({ isHO }) => isHO && hotelOnlyStyles};
  ${cardTypesStyles};
`;
